<template>
  <div class="flex-row items-center flex relative bg-gray-900 border border-gray-700 rounded-md text-text-secondary h-8 pr-3">
    <div
      class="relative text-sm focus:ring flex-row flex shadow-inner cursor-pointer pl-3 h-full items-center overflow-hidden"
      v-clipboard:copy="`connect ${ip}:${port}; password ${password}`"
      v-clipboard:success="copySucceeded"
    >
      <p class="flex text-xs font-mono">
        {{ `connect ${ip}:${port}; password` }}
        <span
          :class="{
            'ml-1': true,
            'blur-sm': streamerMode,
          }"
          :title="streamerMode ? $t('play.shared.password_hidden') : null"
        >{{ password }}</span>
      </p>
      <div class="mx-3 w-[1px] h-2/3 bg-gray-700" />
      <div class="flex align-center justify-center cursor-pointer" :title="$t('play.shared.copy_connect_command')">
        <img src="../assets/icons/clipboard.svg" class="min-w-4 min-h-4 duration-100 hover:scale-110" v-if="!state.copySucceeded" />
        <CheckCircleIcon class="min-w-4 min-h-4 h-4 w-4 text-green-400 duration-100 hover:scale-110" v-else />
      </div>
    </div>
    <div class="mx-3 w-[1px] h-2/3 bg-gray-700" />
    <a
      class="flex align-center justify-center cursor-pointer"
      :title="$t('play.server_info.open_game_and_connect')"
      :href="`steam://connect/${raw_ip}:${port}/${password}`">
      <img src="../assets/icons/play.svg" class="min-w-4 min-h-4 duration-100 hover:scale-110" />
    </a>
    <div class="mx-3 w-[1px] h-2/3 bg-gray-700" />
    <button
      :title="$t('play.shared.terminate_server')"
      @click="toggleTerminate"
      class="flex align-center justify-center w-4 h-4 items-center cursor-pointer text-white border-transparent duration-100 hover:scale-110"
    >
      <svg
        class="animate-spin h-full font-normal w-4"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        v-if="state.isTerminating"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <img src="../assets/icons/x.svg" class="min-w-4 min-h-4" v-else-if="!state.terminateSucceeded" />
      <CheckCircleIcon class="min-w-4 min-h-4" v-else />
    </button>
  </div>
  <button
    @click="navToServer"
    type="button"
    class="inline-flex ml-3 rounded-md items-center px-3 h-8 border select-none border-transparent text-sm text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500"
  >
    {{ $t('play.server_info.manage') }}
  </button>

</template>

<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import {
  ClipboardDocumentIcon, CheckCircleIcon, XCircleIcon, PlayIcon,
} from '@heroicons/vue/24/outline';

export default {
  data() {
    return {
      state: {
        copySucceeded: false,
        terminateSucceeded: false,
        isTerminating: false,
      },
    };
  },
  props: {
    ip: String,
    raw_ip: String,
    port: Number,
    password: String,
    id: Number,
    isAssessment: Boolean,
    streamerMode: Boolean,
  },
  components: {
    ClipboardDocumentIcon,
    CheckCircleIcon,
    XCircleIcon,
    PlayIcon,
  },
  computed: {
    ...mapState(['activeTeam']),
  },
  methods: {
    ...mapMutations(['showMessage', 'updateActiveTeamData', 'setActiveServer']),
    navToServer() {
      this.$router.push('/server_manager');
    },
    copySucceeded() {
      this.state.copySucceeded = true;
      setTimeout(() => {
        this.state.copySucceeded = false;
      }, 1000);
    },
    finishTerminate() {
      setTimeout(() => {
        this.state.terminateSucceeded = true;
        this.state.isTerminating = false;
        setTimeout(() => {
          this.state.terminateSucceeded = false;
        }, 2000);
      }, 5000);
    },
    toggleTerminate() {
      if (this.isTerminating || this.state.terminateSucceeded) return;
      if (confirm(this.$t('play.shared.confirm_terminate'))) {
        this.state.isTerminating = true;
        axios({
          url: `/cs_servers/${this.id}`,
          method: 'DELETE',
          headers: {
            'X-TEAM-ID': this.activeTeam.id,
          },
        })
          .then(() => {
            this.finishTerminate();
          })
          .catch(() => {
            this.state.isTerminating = false;
            this.showMessage({
              messageType: 'error',
              messageText: this.$t('play.server_info.terminate_failed'),
            });
          });
      }
    },
  },
};
</script>
